import React from "react"
import { Link } from "gatsby"

import * as style from "./Sidebar.module.scss"

const SidebarResource = ({
  resource, location, className = '',
}) => (
  <Link
    className={`${style.link} ${className}`}
    to={resource.path}
    data-no-verb
  >
    <p>{resource.title}</p>
  </Link>
)

export default SidebarResource
